const testimonials = [
  {
    name: "Pastor Kevin M.",
    location: "Broken Arrow, OK",
    rating: 5,
    text: "We had 12 youth going on a mission trip to Guatemala with some passports expiring. Fast Passport Center handled the group processing and got everything done in 8 days. Miracle workers!",
    service: "Group Mission Trip Processing",
  },
  {
    name: "Lisa T.",
    location: "Rose District, BA",
    rating: 5,
    text: "My husband's passport was stolen a week before our anniversary trip to Italy. Fast Passport Center had a replacement in our hands in 4 days. Saved our trip!",
    service: "Lost Passport Replacement",
  },
  {
    name: "James P.",
    location: "Broken Arrow, OK",
    rating: 5,
    text: "Business travel to Singapore — needed my passport renewed urgently. The team handled everything remotely and delivered in 3 business days. Incredible.",
    service: "Emergency Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function BrokenArrowTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Broken Arrow Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Broken Arrow, Rose District, Bixby, and Jenks travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}